<template>
	<div
		k-data-id="loginPrompt-container"
		class="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
		<div class="max-w-md w-full mx-4">
			<div k-data-id="loginPrompt-card" class="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
				<!-- Logo -->
				<div
					v-if="appData?.logo"
					k-data-id="loginPrompt-header-logoContainer"
					class="flex justify-center mb-6">
					<img
						k-data-id="loginPrompt-header-logo"
						:src="appData.logo"
						:alt="appData.name"
						class="h-16 w-auto" />
				</div>

				<!-- App Name -->
				<h1
					v-if="appData?.name"
					k-data-id="loginPrompt-header-title"
					class="text-2xl font-bold text-center text-gray-900 dark:text-white mb-2">
					{{ appData.name }} Admin For
					<br />
					{{ tenant?.name }}
				</h1>

				<!-- Message -->
				<p
					k-data-id="loginPrompt-content-message"
					class="text-center text-gray-600 dark:text-gray-400 mb-6">
					You are not logged in. Please login to access this platform.
				</p>

				<!-- Login Button -->
				<a
					k-data-id="loginPrompt-action-loginButton"
					href="./login"
					class="block w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-lg text-center transition-colors">
					Login
				</a>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted, inject } from 'vue'
import { doc, getDoc } from 'firebase/firestore'
import { defaultDb } from '@root/firebaseDatabase'

const appData = ref(null)
const tenant = inject('tenant')

onMounted(async () => {
	try {
		const utilityRef = doc(defaultDb, 'komunily', 'utility')
		const utilityDoc = await getDoc(utilityRef)

		if (utilityDoc.exists()) {
			const data = utilityDoc.data()
			appData.value = {
				logo: data.logo,
				name: data.name
			}
		}
	} catch (error) {
		console.error('Error fetching utility data:', error)
	}
})
</script>
